<template>
    <div class="d-flex flex-column" :class="containerClasses">
        <v-img v-bind="$attrs" :src="layout.file">
            <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate class="dark-blue-color"></v-progress-circular>
                </v-row>
            </template>
        </v-img>

        <label v-if="layout.label" v-text="layout.label"></label>
    </div>
</template>

<script>
export default {
    props: {
        layout: {
            type: Object,
            required: true,
        },

        classes: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        containerClasses() {
            return {
                ...this.classes,
                'justify-start': this.layout.alignment === 'left',
                'justify-center': this.layout.alignment === 'center',
                'justify-end': this.layout.alignment === 'right',
            };
        },
    },
};
</script>
